import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const MaintenanceOutageBanner = () => import(/* webpackChunkName: "4-feat-maintenance-outage-banner" */ './MaintenanceOutageBanner');

export default lazyLoadOnRender({ loader: MaintenanceOutageBanner });